import type { UnknownEnum } from './unknown-value.interface';

export enum DeviceDiskUsed {
  Low = "LOW",
  Fifty = "50",
  Sixty = "60",
  Seventy = "70",
  Eighty = "80",
  Ninety = "90",
}

export type DeviceDiskUsedOrUnknown = DeviceDiskUsed | UnknownEnum;

/**
 * Free-space level shown by the Storage by OU report.
 * `DeviceDiskUsed` buckets are percent of disk *used*, so the most-free
 * bucket (LOW, < 50% used) is High Storage and 90%+ used is Critical.
 */
export enum StorageLevel {
  High = 'high',
  Moderate = 'moderate',
  Low = 'low',
  Critical = 'critical',
  Unknown = 'unknown',
}

/** Display labels in report column order. */
export const STORAGE_LEVEL_LABELS: Record<StorageLevel, string> = {
  [StorageLevel.High]: 'High Storage (>50% free)',
  [StorageLevel.Moderate]: 'Moderate Storage (20-50% free)',
  [StorageLevel.Low]: 'Low Storage (10-20% free)',
  [StorageLevel.Critical]: 'Critical Storage (<10% free)',
  [StorageLevel.Unknown]: 'Unknown',
};

export function storageLevelOf(diskUsed: unknown): StorageLevel {
  switch (String(diskUsed)) {
    case DeviceDiskUsed.Low:
      return StorageLevel.High;
    case DeviceDiskUsed.Fifty:
    case DeviceDiskUsed.Sixty:
    case DeviceDiskUsed.Seventy:
      return StorageLevel.Moderate;
    case DeviceDiskUsed.Eighty:
      return StorageLevel.Low;
    case DeviceDiskUsed.Ninety:
      return StorageLevel.Critical;
    default:
      return StorageLevel.Unknown;
  }
}
